export default __webpack_public_path__ + "static/media/Chart-ATF.ded33c65.jpg";